import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
  standalone: true,
})
export class InitialsPipe implements PipeTransform {
  transform(value: { firstName: string; lastName: string }): string {
    if (!value || !value.firstName || !value.lastName) {
      return '';
    }
    return `${value.firstName.charAt(0).toUpperCase()}${value.lastName.charAt(0).toUpperCase()}`;
  }
}
